// ============================================================
// Einstiegspunkt für index.html
//
// Der Code ist weiterhin Vanilla JS. Vite bündelt ihn nur — die Dateien
// werden hier in fester Reihenfolge importiert und legen ihre geteilten
// Funktionen und Variablen auf window ab (siehe den "Bruecke zu window"-
// Block am Ende jeder Datei).
//
// REIHENFOLGE IST WICHTIG:
//   1. Bibliotheken und der Supabase-Client — app.js braucht _supabase sofort
//   2. app.js — legt die meisten globalen Variablen an. ES-Module laufen im
//      Strict Mode, deshalb muss eine Variable als window-Eigenschaft
//      existieren, bevor irgendwo "currentUser = ..." zugewiesen wird.
//   3. Der Rest.
// ============================================================

import "../style.css";

// Sprachumschaltung zuerst: Sie uebersetzt beim DOMContentLoaded alles
// mit data-i18n und stellt window.t fuer die uebrigen Module bereit
// (caller.js liest darueber seine Rueckfalltexte).
import "../i18n.js";

// --- Bibliotheken global bereitstellen (Legacy-Code erwartet sie so) ---
import Chart from "chart.js/auto";

window.Chart = Chart;

// Entfallen am 08.08.2026 mit dem Handy-Modus: der QRCode-Adapter und
// LivekitClient. Beide gab es nur, damit camera.js das Handy als Webcam
// einbinden konnte - siehe Kopf von camera.js.

// --- Supabase-Client (setzt window._supabase) ---
import "./supabase-client.js";

// --- Anwendungscode ---
import "../dartboard.js";
import "../board-input.js";
// ui-kit vor app.js: Toasts, Modale und Darstellungsgroesse sind aus ui.js
// ausgelagert (Refactor 07.08.2026) und werden von allen Modulen erwartet.
import "../ui-kit.js";
// Vor den Spielmodulen: game-501.js und game-secure.js holen sich die
// Bot-Stufen ueber window (bot.js, 15.08.2026).
import "../bot.js";
// Gemeinsamer Endbildschirm (29.08.2026) - vor den Spielmodulen, die ihn
// beim Spielende aufrufen.
import "../endbildschirm.js";
// Spielwache (29.08.2026): Verlassen-Warnung + Fortsetzen-Kachel - vor den
// Spielmodulen, die sich bei ihr an- und abmelden.
import "../spielwache.js";
import "../app.js";
import "../auth.js";
import "../ui.js";
import "../game-secure.js";
import "../game-secure-online.js";
import "../game-501.js";
import "../game-party.js";
import "../game-bobs.js";
import "../game-rtw.js";
import "../stats.js";
import "../profile.js";
import "../friends.js";
import "../camera.js";
import "../game-121.js";
import "../game-cricket.js";
import "../setup-kit.js";
import "../autoscore.js";
// OBS-Szenenwechsel (Checkout-Zoom). Laedt obs-websocket-js nur bei
// eingeschalteter Anbindung nach (dynamischer Import in obs.js).
import "../obs.js";
// Caller (Sprachansage). Haengt sich an "secure-darts:wurf" aus
// game-501.js - deshalb NACH game-501.js geladen.
import "../caller.js";
import "../game-random.js";
import "../game-gotcha.js";
import "../game-scoring.js";
